<template>
  <div>
      <h1 class="mb-8 font-bold text-3xl">Reports</h1>
      <div class="mb-6 justify-between items-center topFilterBar" v-if="$page.props.auth.user.owner">
        <button class="btn-indigo" v-on:click="toggleReport(false, false)" v-if="reportPerBusiness"> Per Month </button>
        <button class="btn-indigo" v-on:click="toggleReport(false, true)" v-if="reportPerBusiness"> Per Year </button>
        <button class="btn-indigo" v-on:click="toggleReport(true, false)" v-if="!reportPerBusiness"> Per Business </button>

        <button class="btn-indigo" v-on:click="xmlInvoices(true)" v-if="reportPerBusiness"> XML Invoices </button>
        <button class="btn-indigo" v-on:click="shortInvoices(true)" v-if="reportPerBusiness"> Short Invoices </button>
      </div>

    <div v-if="reportPerBusiness">
      <div class="bg-white rounded-md shadow overflow-x-auto">

      <!-- <h3 class="mb-8 font-bold text-xl">Total Amount for all kitchens for current Month : </h3> -->
      <!-- <h3 class="mb-8 font-bold text-xl">Total Amount for all kitchens for current year : </h3> -->

        <table class="w-full whitespace-nowrap">
          <tr class="text-left font-bold">
            <th class="px-6 pt-6 pb-4">{{__('Bakery Name')}}</th>
            <th class="px-6 pt-6 pb-4">{{__('City')}}/{{__('Town')}}</th>
            <th class="px-6 pt-6 pb-4">Month</th>
            <th class="px-6 pt-6 pb-4">Total Orders</th>
            <th class="px-6 pt-6 pb-4">Order Quantity</th>
            <th class="px-6 pt-6 pb-4">Invoiced Amount (with shipping)</th>
            <th class="px-6 pt-6 pb-4">Total Organization Cost</th>
            <th class="px-6 pt-6 pb-4">Shipping Fee</th>
            <!-- <th class="px-6 pt-6 pb-4" v-if="$page.props.auth.user.owner">Action</th> -->
          </tr>
          <tr v-for="order in ordersPerBusiness.data" :key="order.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
            <td class="border-t p-4">
                    {{ order.contact.business_name}} 
              </td>
              <td class="border-t p-4">
                    {{ order.contact.city }}
              </td>
              <td class="border-t p-4">
                    {{ order.month }}
              </td>
              <td class="border-t p-4">
                  {{ order.total_orders }}
              </td>
              <td class="border-t p-4">
                  {{ order.quantity }}
              </td>
              <td class="border-t p-4">
                    {{ order.total }} €
              </td>  
              <td class="border-t p-4">
                    {{ order.total_organization }} €
              </td> 
              <td class="border-t p-4">
                  {{ order.total_orders*20 }}
              </td>
              <!-- <td class="border-t p-4" v-if="$page.props.auth.user.owner">
                <button  class="btn-indigo" tabindex="-1" type="button" @click="sendEmail(order)"> Send Email</button>
              </td> -->

          </tr>
          <tr v-if="ordersPerBusiness.data.length === 0">
            <td class="border-t px-6 py-4" colspan="4">{{__('No Records found.')}}</td>
          </tr>
        </table>
      </div>
      <pagination class="mt-6" :links="ordersPerBusiness.links" />
    </div>

    <div v-else-if="reportPerYear">
        <div class="bg-white rounded-md shadow overflow-x-auto">

        <table class="w-full whitespace-nowrap">
          <tr class="text-left font-bold">
            <th class="px-6 pt-6 pb-4">Year</th>
            <th class="px-6 pt-6 pb-4">Total Orders</th>
            <th class="px-6 pt-6 pb-4">Invoiced Amount (with Shipping)</th>
            <th class="px-6 pt-6 pb-4">Total Organization Cost</th>
            <th class="px-6 pt-6 pb-4">Shipping Fee</th>
            <th class="px-6 pt-6 pb-4" colspan="2" v-if="$page.props.auth.user.owner">Action</th>
          </tr>
          <tr v-for="order in ordersPerYear.data" :key="order.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
              <td class="border-t p-4">
                    {{ order.year }}
              </td>
              <td class="border-t p-4">
                  {{ order.total_orders }}
              </td>
              <td class="border-t p-4">
                    {{ order.total }} €
              </td>  
              <td class="border-t p-4">
                    {{ order.total_organization }} €
              </td>
              <td class="border-t p-4">
                  {{ order.total_orders*20 }}
              </td>
              <!-- <td class="border-t p-4" v-if="$page.props.auth.user.owner">
                <button  class="btn-indigo" tabindex="-1" type="button" @click="sendEmail(order)"> Send Email</button>
              </td> -->
              <td class="border-t w-px">
                <a class="btn-indigo csvbtn" target="_blank" :href="route('reports.csv', order.year)" v-if="$page.props.auth.user.owner">
                  <span class="hidden md:inline">Download</span>
                </a>
            </td>
            <td class="border-t w-px">
                <a class="btn-indigo csvbtn" target="_blank" :href="route('reports.csvProducts', order.year)" v-if="$page.props.auth.user.owner">
                  <span class="hidden md:inline">Download List</span>
                </a>
            </td>

          </tr>
          <tr v-if="ordersPerMonth.data.length === 0">
            <td class="border-t px-6 py-4" colspan="4">{{__('No Records found.')}}</td>
          </tr>
        </table>
      </div>
      <pagination class="mt-6" :links="ordersPerMonth.links" />

    </div>
    <div v-else>
      <div class="bg-white rounded-md shadow overflow-x-auto">

        <table class="w-full whitespace-nowrap">
          <tr class="text-left font-bold">
            <th class="px-6 pt-6 pb-4">Month</th>
            <th class="px-6 pt-6 pb-4">Total Orders</th>
            <th class="px-6 pt-6 pb-4">Invoiced Amount (with Shipping)</th>
            <th class="px-6 pt-6 pb-4">Total Organization Cost</th>
            <th class="px-6 pt-6 pb-4">Shipping Fee</th>
            <th class="px-6 pt-6 pb-4" colspan="2" v-if="$page.props.auth.user.owner">Action</th>
          </tr>
          <tr v-for="order in ordersPerMonth.data" :key="order.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
              <td class="border-t p-4">
                    {{ order.month }}
              </td>
              <td class="border-t p-4">
                  {{ order.total_orders }}
              </td>
              <td class="border-t p-4">
                    {{ order.total }} €
              </td>  
              <td class="border-t p-4">
                    {{ order.total_organization }} €
              </td>
              <td class="border-t p-4">
                  {{ order.total_orders*20 }}
              </td>
              <!-- <td class="border-t p-4" v-if="$page.props.auth.user.owner">
                <button  class="btn-indigo" tabindex="-1" type="button" @click="sendEmail(order)"> Send Email</button>
              </td> -->
              <td class="border-t w-px">
                <a class="btn-indigo csvbtn" target="_blank" :href="route('reports.csv', order.month_year)" v-if="$page.props.auth.user.owner">
                  <span class="hidden md:inline">Download</span>
                </a>
            </td>
            <td class="border-t w-px">
                <a class="btn-indigo csvbtn" target="_blank" :href="route('reports.csvProducts', order.month_year)" v-if="$page.props.auth.user.owner">
                  <span class="hidden md:inline">Download List</span>
                </a>
            </td>

          </tr>
          <tr v-if="ordersPerMonth.data.length === 0">
            <td class="border-t px-6 py-4" colspan="4">{{__('No Records found.')}}</td>
          </tr>
        </table>
      </div>
      <pagination class="mt-6" :links="ordersPerMonth.links" />
    </div>
  </div>

  
</template>

<script>
import Icon from '@/Shared/Icon'
import Layout from '@/Shared/Layout'
import Pagination from '@/Shared/Pagination'
import SearchFilter from '@/Shared/SearchFilter'


export default {
  metaInfo: { title: 'Reports' },
  components: {
    Icon,
    Pagination,
    SearchFilter,
  },
  layout: Layout,
  props: {
    ordersPerMonth: Object,
    ordersPerYear: Object,
    ordersPerBusiness: Object,
  },
  data() {
    return {
      form: this.$inertia.form({
        order : []
      }),
      reportPerBusiness: true,
      reportPerYear: false,
    }
  },
  methods: {
    getQuantityLabels1(boxes){
          // console.log('call labels1 = '+boxes)
          this.labels =  (parseInt(boxes)*55000)
          this.tlabels =  (parseInt(this.tlabels) + this.labels)
          return this.labels
    },
    xmlInvoices() {
      this.$inertia.get(this.route('orders.xmlInvoices'))
    },
    shortInvoices() {
      this.$inertia.get(this.route('reports.shortInvoices'))
    },
    getBoxes(quantity){
       if(quantity == 1){
        return '1 Item'
      }else{
        return quantity+' Items'
      }
    },
    toggleReport(val, val1){
      this.reportPerBusiness = val
      this.reportPerYear = val1
    },
    sendEmail(order){
      this.form.order = order
      // this.form.post(this.route('reports.email'))
    }
  },
}
</script>
<style scoped>
.pl-2per{
  padding-left: 2%;
}
.csvbtn{
  padding: 0.45rem 1rem 0.55rem 1rem;
  margin-right: 1rem;
}
</style>
